export const DADOS_INVALIDOS = 'Dados informados não são inválidos'
export const TOKEN_INVALIDO = 'O token não é válido'
export const EMAIL_ENVIADO = 'E-mail enviado, favor verificar a caixa de entrada'
export const LINK_INVALIDO = 'Link utilizado é inválido'
export const USUARIO_ALTERADO = 'Dados do usuário foram alterados'
export const USUARIO_NAO_ALTERADO = 'Dados do usuário não foram alterados'
